
export const DEV_ENV = false;
export const LOG = false;
export const APP_NAME = 'Indgigs';
export const APP_LOGO = `${process.env.PUBLIC_URL || ''}/images/logo.png`;
export const APP_LOGO_INVERSE = `${process.env.PUBLIC_URL || ''}/images/logo-inverse.png`;
export const DASHBOARD_PATH = '/dashboard';
export const ADMIN_TOKEN_KEY = 'ADMIN_TOKEN_KEY';
export const SUPERADMIN_TOKEN_KEY = ADMIN_TOKEN_KEY;
export const STAFF_TOKEN_KEY = 'STAFF_TOKEN_KEY';
export const SUBDOMAIN_KEY = 'SUBDOMAIN_KEY';
export const USER_ORG_CODE_KEY = 'USER_ORG_CODE_KEY';
export const DEFAULT_ORG_CODE = 'pulkit';
export const BROKEN_DATE_PCIKER_FORMATTING = false;

export const ROUTES = {
  DASHBOARD: '/dashboard',
  ASSIGNMENTS: '/event-diary',
  ASSIGNMENTS_EDIT: (id) => `/event-diary/edit/${id}`,
  STUDY_MATERIAL: '/announcement',
  STUDY_MATERIAL_EDIT: (id) => `/announcement/edit/${id}`,
  STREAMS: '/resources-nexus',
  STREAMS_EDIT: (id) => `/resources-nexus/edit/${id}`,
  CONFERENCES: '/iaept-meeting',
  CONFERENCES_EDIT: (id) => `/iaept-meeting/edit/${id}`,
  QUIZ: '/iaept-civic-consensus',
  QUIZ_EDIT: (id) => `/iaept-civic-consensus/edit/${id}`,
  QUIZ_SUBMITTED: (submitId, streamId) => `/iaept-civic-consensus/submitted_quiz/${submitId}/${streamId}`,
  FEEDBACK: '/chat-with-arbitrator',
  REFERRAL_REWARDS: '/referral-rewards',
  SUBMIT_REFERRAL_DETAILS: '/submit-referral-details',
  REFERRAL_WALLET: '/referral-wallet',
  GEA: '/global-excellence-awards',
  GEA_DETAIL: (id) => `/global-excellence-awards/${id}`,
  TOUR: '/take-a-tour',
  TOUR_DETAIL: (id) => `/take-a-tour/${id}`,
  REWARD_PORTFOLIO: '/referral-reward-portfolio',
  REWARD_PORTFOLIO_DETAIL: (id) => `/referral-reward-portfolio/${id}`,
  SETTINGS: '/profile',
  REPORTS: '/reports',
  VIDEO: '/video',
};

export const MENU_LABELS = {
  DASHBOARD: 'Dashboard',
  EVENT_DIARY: 'Event Diary',
  ANNOUNCEMENT: 'Announcement',
  RESOURCES_NEXUS: 'Resource Nexus',
  IAEPT_MEETING: 'IAEPT Meeting',
  CIVIC_CONSENSUS: 'IAEPT Civic Consensus',
  CHAT_WITH_ARBITRATOR: 'Chat With Arbitrator',
  REFERRAL_REWARDS: 'Referral Rewards',
  GEA: 'Global Excellence Awards',
  SUBMIT_REFERRAL_DETAILS: 'Submit Referral Details',
  REFERRAL_WALLET: 'Referral Wallet',
  TAKE_A_TOUR: 'Take a Tour',
  REWARD_PORTFOLIO: 'Referral Reward Portfolio',
  PROFILE: 'Profile',
};

/*
 * New Variables to be used in conjunction with AxiosHelpers
 */
export const PROTOCOL =  DEV_ENV ? 'http' : 'https';
export const PROD_DOMAIN = 'api.indgigs.com';
export const DEV_DOMAIN = 'IAEPT';
export const ROOT_DOMAIN = DEV_ENV ? DEV_DOMAIN : PROD_DOMAIN;
export const BYPASS_SUBDOMAIN = false;

/**
 * -----------------------------------------
 * DEPRECATED VARAIBLES.
 * NOT USED WITH AxiosHelpers. TO BE AVOIDED
 */
const PROD_URL = () => {
  const subdomain = localStorage.getItem(SUBDOMAIN_KEY);
  return `https://${subdomain}.api.indgigs.com`;
};
const DEV_URL = () => {
  const subdomain = localStorage.getItem(SUBDOMAIN_KEY);
  return `http://${subdomain}.IAEPT.com`;
}
// function must be calles instead of passed value
// NOTE: This is so stupid. Function could have been called here itself and
// been reduced to a constant.
// TODO: Refactor across all APIs to remove unnecessary function calls
export const BASE_URL = DEV_ENV ? DEV_URL : PROD_URL;
export const DOMAIN_URL = DEV_ENV ? 'http://IAEPT.com' : 'https://api.indgigs.com';
/**
 * DEPRECATED VARIABLES END
 * -----------------------------------------
 */

export const DEBOUNCE_DELAY_VALUE = 750;
export const OTP_DISABLE_THRESHOLD = 0;
export const DEFAULT_SETTINGS = {
  default_password: 'password',
  organization_name: 'IAEPT',
  otp_reset_enable: true,
};

export const dropdownHeightModifier = {
  setMaxHeight: {
    enabled: true,
    fn: (data) => {
      return {
        ...data,
        styles: {
          ...data.styles,
          overflow: 'auto',
          maxHeight: '240px',
        },
      };
    },
  },
};

export const STAFF_TYPES = [ 'teaching', 'non_teaching', 'support' ];
export const FEEDBACK_TYPES = [ 'General Query', 'SMS Credit Request', 'Bug Report' ];

export const fakeData = [
    {name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
    {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
    {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
    {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
    {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
    {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
    {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
    {name: 'Page C', uv: 2000, pv: 6800, amt: 2290},
    {name: 'Page D', uv: 4780, pv: 7908, amt: 2000},
    {name: 'Page E', uv: 2890, pv: 9800, amt: 2181},
    {name: 'Page F', uv: 1390, pv: 3800, amt: 1500},
    {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
];

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const FEEDBACK_SOURCES = {
  student: 'App',
  student_web: 'Web Panel',
};

export const STREAM_STATUSES = [ 'Scheduled', 'Ongoing', 'Archived' ];
export const CONFERENCE_STATUSES = [ 'Scheduled', 'Ongoing', 'Archived' ];
export const CONFERENCE_PROVIDERS = {
  ZOOM: 'ZOOM',
};
export const PASSWORD_MINIMUM_LENGTH = 6;
export const LOW_SMS_THRESHOLD = 100;

/** Login / info panel ads — public list, same shape as system_admin ads */
export const INFO_ADS = 'api/v1/system_admin/info_ads';

export const DAYS = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thurs',
  'Fri',
  'Sat',
];
